module.exports = __webpack_public_path__ + "static/media/listBb.04efbaac.png";